import json from './sprite.js';

export default {
    handle: 'ENG_SPT7-Cookie_225002682',
    label: 'en_SPT7-Cookie_225002682',
    json,
};
